
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns9b7500c743a0e60236dd32f2b755a17aen from './en.yaml'
            i18n.addResourceBundle('en', '9b7500c743a0e60236dd32f2b755a17a', flattenObject(ns9b7500c743a0e60236dd32f2b755a17aen), true, true);
        
        export default '9b7500c743a0e60236dd32f2b755a17a';
    